import React from 'react';
import {ReactEditor, useSlateStatic} from 'slate-react';

import {formatPageNumber} from '../utils/formattingUtils';

import {PageContext} from './PageRenderer';

export const PageNumber = ({
  attributes,
  children,
  element,
  pageIndex: overrideIndex
}: any): React.JSX.Element => {
  const editor = useSlateStatic();
  let calculatedIndex = 0;

  const contextIndex = React.useContext(PageContext);

  if (overrideIndex !== undefined) {
    calculatedIndex = overrideIndex;
  } else if (contextIndex !== undefined) {
    calculatedIndex = contextIndex - 1; // context is 1-based, formatPageNumber expects 0-based
  } else {
    try {
      const path = ReactEditor.findPath(editor as any, element);
      if (path && path.length > 0) {
        calculatedIndex = path[0];
      }
    } catch (e) {}
  }

  const format = element.format || '123';
  const displayValue = formatPageNumber(calculatedIndex, format);

  return (
    <span
      {...attributes}
      contentEditable={false}
      className="slate-page-number"
      style={{
        userSelect: 'none',
        display: 'inline-block',
        padding: '0 2px',
        ...(element.style || {})
      }}
    >
      {displayValue}
      {children}
    </span>
  );
};
